import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
// import { combineReducers } from "redux";
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
    rejectionReason: {
        value: "",
        error: "",
        showError: "",
    },
}

const namespacers = {
    rejectPackage: createNamespacer("PACKAGE_REJECT"),
}

const rejectReducer = createReducer(initialState,{
    [namespacers.rejectPackage("SET_REJECTION_REASON")] : (state,action) => {
        return {
            ...state,
            rejectionReason : {
                ...state.rejectionReason,
                value : action.payload.value
            },
        }
    },
    [namespacers.rejectPackage("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
    [namespacers.rejectPackage("CLEAR_FORM")]: (state,action) => {
        return{
            ...state,
            rejectionReason:{
                ...initialState.rejectionReason
            }
        }
    },
})


export default rejectReducer;